import {Pipe, PipeTransform}    from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({standalone:true,name: 'sanitizeHtml'})
export class SafeHtmlPipe implements PipeTransform {

    constructor(private _sanitizer: DomSanitizer) {
    }

    transform(value: string): SafeHtml {
      if(value){
        return this._sanitizer.bypassSecurityTrustHtml(value);
      }
      return '';
    }

}
